export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9613.5c4e298b.jpg";